import { useCallback } from "react";
import { usePreference } from "./use-preference";
import { getSelectedTenantId } from "@/lib/tenant-selection";

export function useSidebarFavourites() {
  const tenantId = getSelectedTenantId() ?? "default";
  const prefKey = `sidebar-favourites-v1:${tenantId}`;
  const [favouriteIds, setFavouriteIds] = usePreference<string[]>(prefKey, []);

  const pin = useCallback(
    (id: string) => {
      setFavouriteIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
    },
    [setFavouriteIds],
  );

  const unpin = useCallback(
    (id: string) => {
      setFavouriteIds((prev) => prev.filter((x) => x !== id));
    },
    [setFavouriteIds],
  );

  const isFavourited = useCallback(
    (id: string) => favouriteIds.includes(id),
    [favouriteIds],
  );

  return { favouriteIds, pin, unpin, isFavourited };
}
